import styled from 'styled-components';
import {commonPalette} from 'styles/palette';

export const ReportCheckPanelWrapper = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;

export const MainContentWrapper = styled.div`
  flex: 1;
  overflow-y: auto;
`;

export const Description = styled.p`
  font-size: 18px;
  color: ${commonPalette.textPrimary};
  padding-bottom: 16px;
  font-size: 14px;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 24px;
  flex-direction: row;
  gap: 16px;
`;

export const MediaUploaderWrapper = styled.div`
  margin-top: 21px;
  flex: 1;
`;

export const Label = styled.p`
  font-size: 16px;
  font-family: 'Lato';
  color: ${commonPalette.textSecondary};
  padding-bottom: 8px;
`;
